function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable jsx-a11y/anchor-is-valid */

/** @jsx jsx */
import { jsx, css, keyframes } from '@emotion/core';
import React from 'react';
import classNames from 'classnames';
import { useTheme } from 'emotion-theming';
import { useTranslation } from 'react-i18next';
import { migratoryWebCitizen, sanitarianRegistersWeb, phytosanitaryWeb, tdCarWeb } from '../../Colors';
import { SearchIcon, FolderIcon, TrashIcon, GripIcon, ListUlIcon } from '../../../icon';
import DropDownCombo from '../../forms/inputs/DropDownCombo';
import { reducer, mediaQuery } from '../../../utils';
import { SpinnerSmall as Spinner } from '../../../core';
import useMediaQuery from '../../../hooks/use-media-query';
const ViewContext = /*#__PURE__*/React.createContext();
const themes = {
  migratoryWebCitizen: {
    alpha: migratoryWebCitizen.cerulean,
    beta: migratoryWebCitizen.fireEngineRed,
    gama: migratoryWebCitizen.white,
    delta: migratoryWebCitizen.aliceBlue,
    epsilon: migratoryWebCitizen.fireEngineRed,
    eta: migratoryWebCitizen.fireEngineRed,
    zeta: migratoryWebCitizen.cerulean,
    iota: migratoryWebCitizen.prussianBlue
  },
  sanitarianRegistersWeb: {
    alpha: sanitarianRegistersWeb.cerulean,
    beta: sanitarianRegistersWeb.fireEngineRed,
    gama: sanitarianRegistersWeb.white,
    delta: sanitarianRegistersWeb.aliceBlue,
    epsilon: sanitarianRegistersWeb.fireEngineRed,
    eta: sanitarianRegistersWeb.fireEngineRed,
    zeta: sanitarianRegistersWeb.cerulean,
    iota: sanitarianRegistersWeb.prussianBlue
  },
  phytosanitaryWeb: {
    alpha: phytosanitaryWeb.lightSeaGreen,
    beta: phytosanitaryWeb.mantis,
    gama: phytosanitaryWeb.sherpaBlue,
    delta: phytosanitaryWeb.azure,
    epsilon: phytosanitaryWeb.sherpaBlue,
    eta: phytosanitaryWeb.flamingo,
    zeta: phytosanitaryWeb.allports,
    iota: phytosanitaryWeb.sherpaBlue
  },
  tdCarWeb: {
    alpha: tdCarWeb.cerulean,
    beta: tdCarWeb.fireEngineRed,
    gama: tdCarWeb.white,
    delta: tdCarWeb.aliceBlue,
    epsilon: tdCarWeb.fireEngineRed,
    eta: tdCarWeb.fireEngineRed,
    zeta: tdCarWeb.cerulean,
    iota: tdCarWeb.prussianBlue
  }
};
/**
 * This component represent Filter.
 * @param {*} t Translation.
 * @param {Function} onSubmit Submit function on the Filter.
 * @param {JSON} documentsDefinitions Document type values for the dropDown.
 * @param {Boolean} isLoading Loading prop when searching.
 */

export function Filter({
  onSubmit,
  documentsDefinitions,
  isLoading = false
}) {
  const {
    theme
  } = useTheme();
  const {
    t
  } = useTranslation();
  const {
    isMobile
  } = useMediaQuery();
  const [{
    knownNumber,
    identificationNumber,
    identificationTypeId
  }, dispatch] = React.useReducer(reducer, {
    knownNumber: '',
    identificationNumber: '',
    identificationTypeId: ''
  });

  const onKnownNumber = evt => {
    dispatch({
      knownNumber: evt.target.value
    });
  };

  const onChangeIdentificationNumber = evt => {
    dispatch({
      identificationNumber: evt.target.value
    });
  };

  function handleSubmit() {
    onSubmit({
      knownNumber,
      identificationNumber,
      identificationTypeId
    });
  }

  return jsx("div", {
    className: "search-section",
    css: filterStyle
  }, jsx("div", {
    className: "filter"
  }, jsx("div", {
    className: "filter-wrapper combo"
  }, jsx("label", null, t('Tipo de identificación del vehículo'), ":"), jsx(DropDownCombo, {
    items: documentsDefinitions,
    placeholder: t('Seleccionar'),
    value: identificationTypeId,
    style: {
      margin: 0,
      width: '100%',
      marginRight: 5
    },
    onChange: ({
      id
    }) => {
      if (id) {
        dispatch({
          identificationTypeId: id
        });
      } else {
        dispatch({
          identificationTypeId: ''
        });
      }
    }
  })), jsx("div", {
    className: "filter-wrapper"
  }, jsx("label", null, t('Número de identificación del vehículo'), ":"), jsx("div", {
    className: "search"
  }, jsx("input", {
    type: "text",
    placeholder: t('Buscar'),
    value: identificationNumber,
    onChange: onChangeIdentificationNumber,
    maxLength: 255
  }), jsx(SearchIcon, {
    className: "icon",
    css: {
      color: themes[theme].alpha
    }
  })))), jsx("div", {
    className: "filter"
  }, jsx("div", {
    className: "filter"
  }, jsx("div", {
    className: "filter-wrapper"
  }, jsx("label", null, t('Búsqueda por número de conocimiento'), ": "), jsx("div", {
    className: "search"
  }, jsx("input", {
    type: "text",
    placeholder: t('Buscar'),
    value: knownNumber,
    onChange: onKnownNumber,
    maxLength: 255
  }), jsx(SearchIcon, {
    className: "icon",
    css: {
      color: themes[theme].alpha
    }
  })))), jsx("button", {
    type: "button",
    style: {
      backgroundColor: themes[theme].beta,
      marginBottom: 5,
      marginTop: isMobile ? 23 : 0
    },
    onClick: handleSubmit
  }, isLoading ? jsx(Spinner, {
    style: {
      position: 'relative',
      top: 3,
      marginRight: 10
    }
  }) : null, t('Buscar'))));
}

function GridItem({
  data,
  onClick,
  ...props
}) {
  // const { theme } = useTheme()
  const {
    t
  } = useTranslation(); // const isDocumentValid = isAValidDocument(data)
  // const status = classNames('status', { expired: !isDocumentValid })
  // const trash = classNames('icon-trash', { hide: isFunctionary })

  return jsx("li", _extends({
    css: gridItemStyle,
    className: "document",
    onClick: onClick
  }, props), jsx("div", {
    className: "info"
  }, jsx("div", {
    className: "name"
  }, jsx(FolderIcon, {
    className: "icon-folder"
  })), jsx("h4", null, t('Número de conocimiento'), ": ", data.ladingNumber), jsx("p", {
    css: {
      fontWeight: 600,
      fontSize: 12,
      color: '#08415C',
      margin: 0
    }
  }, t('Vehículos'), " ", data.importationType), jsx("span", null, data.name)));
}

function ListItem({
  data,
  isFunctionary = false,
  folder,
  onClick,
  wasCreatedByAProcedure,
  ...props
}) {
  var _data$DocumentDefinit;

  const action = classNames('action', {
    hide: isFunctionary
  });
  const row = classNames('row', {
    'style-1': isFunctionary && wasCreatedByAProcedure,
    'style-2': isFunctionary && !wasCreatedByAProcedure,
    'style-3': !isFunctionary && wasCreatedByAProcedure,
    'style-4': !isFunctionary && !wasCreatedByAProcedure
  });
  return jsx("div", _extends({
    className: row
  }, props), jsx("span", {
    className: "bold"
  }, data.name), jsx("span", null, data === null || data === void 0 ? void 0 : (_data$DocumentDefinit = data.DocumentDefinition) === null || _data$DocumentDefinit === void 0 ? void 0 : _data$DocumentDefinit.name), jsx("span", {
    className: "action"
  }, jsx("a", {
    role: "menu",
    tabIndex: 0,
    onClick: onClick
  }, "ver")), !isFunctionary || !wasCreatedByAProcedure && jsx("span", {
    className: action
  }, jsx(TrashIcon, {
    className: "icon-trash"
  })));
}
/**
 * This component represent an Item.
 * @param {props} t All possible props.
 *
 */


export function Item(props) {
  let viewType = React.useContext(ViewContext);
  /**
   * Si no se usa el contexto que maneja el tipo de vista, por defecto
   * la vista es `grid`
   */

  if (viewType === undefined) {
    viewType = 'grid';
  }

  if (viewType === 'grid') return jsx(GridItem, props);
  return jsx(ListItem, props);
}

function GridWrapper({
  children
}) {
  return jsx("ul", {
    className: "documents grid"
  }, children);
}

function ListWrapper({
  children,
  isFunctionary = false,
  wasCreatedByAProcedure = false
}) {
  const {
    isMobile
  } = useMediaQuery();
  const row = classNames('row', {
    'style-1': isFunctionary && wasCreatedByAProcedure,
    'style-2': isFunctionary && !wasCreatedByAProcedure,
    'style-3': !isFunctionary && wasCreatedByAProcedure,
    'style-4': !isFunctionary && !wasCreatedByAProcedure
  });
  return jsx("div", {
    className: "documents list"
  }, jsx("div", {
    className: "head"
  }, jsx("div", {
    className: row,
    style: {
      backgroundColor: 'transparent',
      marginLeft: isMobile ? 0 : 40
    }
  }, jsx("span", null, "N\xFAmero de conocimiento"), jsx("span", null, "Tipo de veh\xEDculo"))), jsx("div", {
    className: "body"
  }, children));
}
/**
 * This component represent a wrapper.
 * @param {*} children What will be display inside the wrapper.
 * @param {*} props All other posible props
 */


export function Wrapper({
  children,
  ...props
}) {
  const viewType = React.useContext(ViewContext);

  if (viewType === 'grid') {
    return jsx(GridWrapper, props, children);
  }

  return jsx(ListWrapper, props, children);
}
/**
 * This component represent a Container.
 * @param {*} children What will be display inside the container.
 */

export function Container({
  children
}) {
  const [viewType, setViewType] = React.useState('grid');
  return jsx(ViewContext.Provider, {
    value: viewType
  }, jsx("main", {
    css: mainStyles
  }, jsx("div", {
    className: "view-container"
  }, jsx("ul", {
    className: "view-types"
  }, jsx("li", {
    className: viewType === 'grid' ? 'active' : 'inactive',
    style: {
      borderTopLeftRadius: 6,
      borderBottomLeftRadius: 6
    },
    onClick: () => setViewType('grid')
  }, jsx(GripIcon, {
    className: "icon-grip icon"
  })), jsx("li", {
    className: viewType === 'list' ? 'active' : 'inactive',
    style: {
      borderTopRightRadius: 6,
      borderBottomRightRadius: 6
    },
    onClick: () => setViewType('list')
  }, jsx(ListUlIcon, {
    className: "icon-list icon"
  })))), children));
}
export const RecordItemSkeleton = () => jsx("li", {
  css: gridItemStyle,
  className: "document",
  style: {
    marginTop: 50
  }
}, jsx("div", {
  css: skeletonStyle
}, jsx("div", {
  className: "info",
  style: {
    backgroundColor: '#FFFF',
    borderRadius: '6px'
  }
}, jsx("div", {
  className: "name"
}, jsx(FolderIcon, {
  className: "icon-folder"
})), jsx("div", {
  className: "skeleton"
}), jsx("div", {
  className: "skeleton"
}))));

const documentsStyle = theme => `
  a {
    background: ${themes[theme].beta};
    border-radius: 100px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: ${themes[theme].gama};
    text-transform: uppercase;
    padding: 3px 0;
    grid-column-start: 2;
    width: 64px;
    height: 16px;
    text-align: center;
    justify-self: center;
    cursor: pointer;
  }

  .icon-trash {
    width: 14px;
    height: 17px;
    fill: ${themes[theme].alpha};
    justify-self: end;
  }

  .status.expired {
    .icon-status {
      fill: ${themes[theme].eta}
    }
    span {
      color:${themes[theme].eta};
    }
  }

  .status {
    display: flex;
    align-items: center;
    .icon-status {
      width: 16px;
      height: 16px;
      fill: #0f7cb5;
    }

    span {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: ${themes[theme].zeta};
      margin-left: 10px;
    }
  }
`;

const mainStyles = ({
  theme = 'migratoryWebCitizen'
}) => css`
  background-color: ${themes[theme].gama};
  padding-top: 25px;
  padding-bottom: 79px;
  border-radius: 6px;
  margin-top: 28px;

  .view-container {
    display: flex;
    justify-content: flex-end;

    .view-types {
      display: flex;
      margin: 0;
      padding: 0;
      list-style: none;
      width: 150px;
      float: right;
      border-radius: 10px;

      li {
        padding: 8px 13px;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        color: ${themes[theme].epsilon};
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 123px;
        flex-wrap: wrap;
        cursor: pointer;

        .icon-grip {
          fill: ${themes[theme].epsilon};
          width: 21px;
          height: 21px;
          margin-right: 6px;
        }

        .icon-list {
          fill: ${themes[theme].epsilon};
          width: 22px;
          height: 18px;
          margin-right: 6px;
        }
      }

      li.active {
        background-color: ${themes[theme].beta};
        color: ${themes[theme].gama};
        .icon {
          fill: ${themes[theme].gama};
        }
      }
      li.inactive {
        background-color: #a0b9c8;
        color: ${themes[theme].gama};
        .icon {
          fill: #859dab;
        }
      }
    }
  }

  .documents {
    ${documentsStyle(theme)}
  }

  .hide {
    display: none !important;
  }

  .documents.list {
    margin-top: 25px;

    .row {
      display: grid;
      background-color: #f4fbfe;
      margin-top: 12px;
      border-radius: 10px;
    }

    .row.style-1 {
      grid-template-columns: 30% 50% 20%;
    }

    .row.style-2 {
      grid-template-columns: 30% 50% 20%;
    }

    .row.style-3 {
      grid-template-columns: 30% 50% 20%;
    }

    .row.style-4 {
      grid-template-columns: 30% 50% 20%;
    }

    .body {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 20px;
      color: #313131;

      .action {
        display: flex;
        justify-content: flex-end;

        a {
          display: inline-block;
          cursor: pointer;
        }
      }

      .row {
        padding: 25px;
        box-sizing: border-box;

        span {
          margin-right: 6px;
        }
      }

      .bold {
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 16px;
        color: #0d1f2d;
      }
    }

    .head {
      span {
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 20px;
        color: ${themes[theme].zeta};
      }
    }
  }

  .documents.grid {
    cursor: pointer;
    list-style: none;
    margin: 23px 0 0 0;
    padding: 0;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 35px;
    ${mediaQuery[0]} {
      grid-template-columns: 1fr;
      margin: 0;
      gap: 12px;
    }
  }
`;

const gridItemStyle = ({
  theme = 'migratoryWebCitizen'
}) => css`
  background-color: #ebf1f4;
  border-radius: 10px;
  ${documentsStyle(theme)}

  .info {
    padding: 35px;

    .name {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }

    h4 {
      margin: 4px 0px;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 16px;
      color: #08415c;
    }

    span {
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 16px;
      color: #08415c;
    }

    .icon-folder {
      width: 58px;
      height: 55.5px;
      fill: #08415c;
    }

    .item {
      display: block;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 25px;
      color: #313131;

      .solid {
        font-weight: bolder;
      }
    }

    .status {
      margin-top: 10px;
    }
  }

  .divider {
    border-top: 0.5px solid #aacde0;
  }

  .actions {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    align-items: center;
    padding: 12px 26px;
  }
`;

const filterStyle = ({
  theme = 'migratoryWebCitizen'
}) => css`
  .filter {
    display: flex;
    align-items: center;
    ${mediaQuery[0]} {
        flex-direction: column;
      }
    .filter-wrapper {
      margin-bottom: 23px;
      ${mediaQuery[0]} {
        width: 100%;
      }

      .search {
        width: 100%;
        position: relative;
        input {
          background: #ffffff;
          border: 1px solid #0f7cb5;
          box-sizing: border-box;
          border-radius: 4px;
          height: 34px;
          padding: 0 30px;
          ::placeholder{
            color: #AACDE0;
        }
          ${mediaQuery[0]} {
            height: 46px;
          }
        }

        .icon {
          width: 18px;
          height: 18px;
          fill: #0f7cb5;
          position: absolute;
          top: 8px;
          left: 8px;
          ${mediaQuery[0]} {
            top: 14px;
          }
        }
      }
    }

    div {
      label {
        margin-bottom: 5px;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #282828;
        padding-left: 10px;
      }
    }

    .combo {
        margin-right: 15px;
        ${mediaQuery[0]} {
            margin-right: 0px;
          }
      input {
        background: transparent;
        height: 34px;
        border: 1px solid #0f7cb5;
        ::placeholder{
            color: #AACDE0;
        }
        ${mediaQuery[0]} {
          height: 46px;
        }
      }
    }

      div {
        width: 100%;
        display: flex;
        flex-direction: column;
        ${mediaQuery[0]} {
          width: 100%;
          height: 62px;
        }
      }

      button {
        width: 20%;
        margin-left: 20px;
        border-radius: 6px;
        border: ${themes[theme].beta};
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        text-transform: uppercase;
        color: ${themes[theme].gama};
        height: 34px;
        align-items: end;
        ${mediaQuery[0]} {
          width: 100%;
          margin-left: 0px;
          margin-top: 5px;
          height: 38px;
        }
      }
    }
  }
`;

const shimmer = keyframes`
  100% {
    transform: translateX(100%)
  }
`;

const skeletonStyle = () => css`
.skeleton {
  display: inline-block;
  height: 20px;
  position: relative;
  background-color: #D7E7F0;
  overflow: hidden;
  width: 100%;
}

.skeleton{  
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.2) 20%,
      rgba(255, 255, 255, 0.5) 60%
    );
    animation: ${shimmer} 2s infinite;
    content: '';
  }
`;